import React from "react";
import { SANS_2, SANS_3, UI_BODY_SM_DF } from "oolib";

import { createContentCardDate } from "../../../../../../utils/momentManipulate";

const DateDisplay = ({
  value,
  textComp = "UI_BODY_SM_DF",
  createContentCardDateFnOptions = {
    format: "DD/MM/YYYY",
    switchDisplayFormatAfter: 0,
  },
  ...textCompProps
}) => {
  const TextComps = {
    SANS_3,
    SANS_2,
    UI_BODY_SM_DF,
  };

  const TextComp = TextComps[textComp];

  const date = createContentCardDate(
    value,
    null,
    null,
    createContentCardDateFnOptions
  );

  return <TextComp {...textCompProps}>{date || " "}</TextComp>;
};

export default DateDisplay;
